'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  color: ', '\n'], ['\n  text-align: center;\n  color: ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Title = _styledComponents2.default.h1(_templateObject, function (props) {
  return props.color || '#000';
});

/** @class TitleContent
  * A content representing a title
  * @param {string} text - the text to display
  * @param {CSSColor} color - the color to render the text in (default black)
  */

var TitleContent = function (_Component) {
  _inherits(TitleContent, _Component);

  function TitleContent() {
    _classCallCheck(this, TitleContent);

    return _possibleConstructorReturn(this, (TitleContent.__proto__ || Object.getPrototypeOf(TitleContent)).apply(this, arguments));
  }

  _createClass(TitleContent, [{
    key: 'render',

    /** @function
     * Renders the Title Content component.
     */
    value: function render() {
      if (!this.props.text) return null;
      return _react2.default.createElement(
        Title,
        null,
        this.props.text
      );
    }
  }]);

  return TitleContent;
}(_react.Component);

exports.default = TitleContent;


TitleContent.propTypes = {
  text: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/title-content.js
// module id = 1318
// module chunks = 0